/*
 * Copyright (c) 2022. Dave van Rijn Development
 */

import React from "react";
import {Navigation} from "./util/interfaces";
import {HeaderItem, sendGaEvent} from '@dvrd/dvr-controls';
import Home from "./components/home/home";
import {pageScroller} from "./util/utils";
import ContactPage from "./components/contact/page/contactPage";
import ServicePage from "./components/service/servicePage";
import PricesPage from "./components/prices/pricesPage";
import {Route, Routes} from "react-router";
import {afterNavigate} from "./util/navigationUtil";

export const NavigationItems: Navigation[] = [
    {
        label: 'Contact',
        authenticated: false,
        component: <ContactPage/>,
        scrollId: 'contact',
        route: '/contact',
        order: 4
    },
    {label: 'Werkwijze', authenticated: false, component: <ServicePage/>, scrollId: 'service', route: '/werkwijze', order: 1},
    {label: 'Tarieven', authenticated: false, component: <PricesPage/>, scrollId: 'prices', route: '/tarieven', order: 2},
    {label: 'Home', authenticated: false, component: <Home/>, scrollId: '', route: '/', order: 0},
];

export const getHeaderItems = (): HeaderItem[] => {
    const items = NavigationItems.slice();
    items.sort((itemA, itemB) => (itemA.order || 0) - (itemB.order || 0));
    return items.map(createHeaderItem)
};

const onNavigate = (route: string, id?: string) => () => {
    window.location.assign(route);
    afterNavigate(route, true, id, pageScroller);
    // navigate(route, true, id, pageScroller);
};

const createHeaderItem = (item: Navigation): HeaderItem => ({
    onClick: onClickHeaderItem(item),
    label: item.label,
    children: item.subNavigation?.map(createHeaderItem),
    route: item.route,
    id: item.scrollId
});

const onClickHeaderItem = (item: Navigation) => () => {
    sendGaEvent('click', 'header', item.label);
    onNavigate(item.route, item.scrollId)();
};

export function AppRoutes() {
    return (
        <Routes>
            <Route path='/contact' element={<ContactPage/>}/>
            <Route path='/werkwijze' element={<ServicePage/>}/>
            <Route path='/tarieven' element={<PricesPage/>}/>
            <Route index element={<Home/>}/>
        </Routes>
    )
}